import {config, library} from '@fortawesome/fontawesome-svg-core'
import type {IconDefinition} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {faInstagram, faFacebook, faTiktok, faTwitter, faYoutube, faLinkedin,faSpotify, faApple, } from '@fortawesome/free-brands-svg-icons'

import {
    faAngleLeft,
    faArrowUp as fasArrowUp,
    faArrowLeft as fasArrowLeft,
    faArrowRight as fasArrowRight,
    faBadgeDollar,
    faCapsules as fasCapsules,
    faCartPlus,
    faCircle,
    faCircleQuestion,
    faCow,
    faFill,
    faFlaskRoundPotion,
    faHandshake as fasHandshake,
    faInfoCircle,
    faHeart as fasHeart ,
    faListCheck as fasListCheck,
    faMicroscope as fasMicroscope,
    faPlay,
    faQuoteLeft,
    faQuestion,
    faRabbit,
    faStar,
    faStarHalf,
    faSearch as fasSearch,
    faTriangleExclamation,
    faWheat,
} from '@fortawesome/pro-solid-svg-icons'

import {
    faArrowLeft,
    faArrowUp,
    faArrowRight,
    faAngleUp,
    faAngleDown,
    faArrowRightFromBracket,
    faBarcode,
    faBars,
    faBook,
    faBriefcaseMedical,
    faBullhorn,
    faBolt,
    faCapsules,
    faClipboard,
    faCartShopping,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronUp,
    faChevronRight,
    faChevronLeft,
    faCircleNotch,
    faCog,
    faCommentExclamation,
    faExternalLinkSquareAlt,
    faHashtag,
    faHandshake,
    faHeadSideBrain,
    faLink,
    faListCheck,
    faMicrophone,
    faMicroscope,
    faMinus,
    faMortarPestle,
    faNewspaper,
    faPaperPlane,
    faPauseCircle,
    faPlus,
    faPlayCircle,
    faPodcast,
    faRabbitFast,
    faSearch,
    faStore,
    faSlidersH,
    faTimes,
    faUser,
    faUniversalAccess,
    faVideo,
    faVolumeUp,
    faVolumeMute,
    faX,
} from '@fortawesome/pro-regular-svg-icons'

import {
    faArrowRightArrowLeft as falArrowRightArrowLeft,
    faBroadcastTower as falBroadcastTower,
    faCapsules as falCapsules,
    faCommentExclamation as falCommentExclamation,
    faCoins,
    faComment as falComment,
    faGiftCard,
    faHandshake as falHandshake,
    faInventory,
    faListCheck as falListCheck,
    faMicroscope as falMicroscope,
    faMobile as falMobile,
    faPaperPlane as falPaperPlane,
    faPennant,
    faUserCircle,
    faVial
} from '@fortawesome/pro-light-svg-icons'

config.autoAddCss = false



function addIcons(icons: any[]) {
 (library as any).add(...icons)
}
// FA Brand SVG Icons
// --------------------
// instagram
// facebook
// tiktok
// twitter
// youtube
// linkedin
addIcons([
 faAngleLeft,
 faApple,
 faBadgeDollar,
 faFacebook,
 faInfoCircle,
 faInstagram,
 faLinkedin,
 faPlay,
 faQuestion,
 faQuoteLeft,
 faSpotify,
 faTiktok,
 faTwitter,
 faWheat,
 faYoutube,
 fasArrowLeft,
 fasArrowRight,
 fasArrowUp
] as any)

// FA Solid SVG Icons
// --------------------
// circle
// star
// star-half

addIcons([
 faCircleQuestion,
 faCircle,
 faCow,
 faFill,
 faFlaskRoundPotion,
 faRabbit,
 faStar,
 faStarHalf,
 fasSearch,
 faTriangleExclamation
] as any)

// FA Solid SVG Icons
// --------------------
// cart-plus
// capsules
// circle
// handshake
// list-check
// microscope
// star
// star-half

addIcons([
 faCartPlus,
 faCircle,
 faHashtag,
 faSlidersH,
 faStar,
 faStarHalf,
 fasCapsules,
 fasHandshake,
 fasHeart,
 fasListCheck,
 fasMicroscope
] as any )

// FA Regular SVG Icons
// --------------------
// arrow-left
// arrow-right
// arrow-right-from-bracket
// barcode
// bars
// book
// briefcase-medical
// capsules
// cart-shopping
// check
// check-circle
// chevron-down
// chevron-up
// cog
// handshake
// link
// list-check
// microscope
// minus
// mortar-pestle
// newspaper
// paper-plane
// plus
// search
// store
// times
// user
// video
// x
// rabbit-fast
addIcons([
 faAngleDown,
 faAngleUp,
 faArrowLeft,
 faArrowUp,
 faArrowRight,
 faArrowRightFromBracket,
 faBarcode,
 faBars,
 faBook,
 faBolt,
 faBriefcaseMedical,
 faBullhorn,
 faCapsules,
 faCartShopping,
 faCheck,
 faCheckCircle,
 faChevronDown,
 faChevronUp,
 faChevronRight,
 faChevronLeft,
 faCircleNotch,
 faClipboard,
 faCog,
 faCommentExclamation,
] as any )

addIcons([
 faExternalLinkSquareAlt,
 faHandshake,
 faHeadSideBrain,
 faLink,
 faListCheck,
 faMicroscope,
 faMicrophone,
 faMinus,
 faMortarPestle,
 faNewspaper,
 faPaperPlane,
 faPauseCircle,
 faPlayCircle,
 faPlus,
 faPodcast,
 faRabbitFast,
 faSearch,
 faSlidersH,
 faStore,
 faTimes,
 faUniversalAccess,
 faUser,
 faVideo,
 faVolumeMute,
 faVolumeUp,
 faX,
]as any )

// FA Light SVG Icons
// --------------------
// capsules
// handshake
// microscope
// list-check
addIcons([
 falArrowRightArrowLeft,
 falBroadcastTower,
 falCapsules,
 falCommentExclamation,
 faCoins,
 falComment,
 faGiftCard,
 falHandshake,
 faInventory,
 falListCheck,
 falMicroscope,
 falMobile,
 falPaperPlane,
 faPennant,
 faUserCircle,
 faVial
] as any)

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component('font-awesome-icon', FontAwesomeIcon as any);
});